import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { concatMap, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';

import { Actions } from '../../actions';
import {
  CreateMerchError,
  CreateSampleOrder,
  CreateSampleOrderError,
  CreateSampleOrderSuccess,
  UpdateMerch,
  ValidateMerchProductSampleError,
} from '../action-creators';
import { CREATE_MERCH_PRODUCT_SAMPLE_ORDER } from '../actions';
import {
  createMerchRequest,
  createMerchSampleOrderRequestBody,
} from '../selectors';
import AppState from '@webapp/store/state';
import ApiError from '@common/types/api/api-error';
import { UpdateProductRequest } from '@services/merch/types/api/update-product';

export const createSampleOrderEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateSampleOrder>(CREATE_MERCH_PRODUCT_SAMPLE_ORDER),
    withLatestFrom(state$),
    mergeMap(async ([_, state]) => {
      try {
        const productId =
          (state.merch.active?.editProduct
            ? state.merch.active?.editProduct.id
            : state.merch.active?.newProduct
            ? state.merch.active?.newProduct?.productId
            : state.merch.active?.product
            ? state.merch.active?.product?.id.toString()
            : '') || '';
        const productSample = state.merch.active?.productSample;
        const editProduct = state.merch.active?.editProduct;
        const newProduct = state.merch.active?.newProduct;

        const phoneNumber =
          state.user.profile?.telephone ||
          state.user.profile?.notVerifiedTelephone ||
          state.artist.active?.telephone;
        const email = state.artist.active?.email;
        const artistId = state.artist.active?.id;

        if (
          productSample &&
          productSample?.shippingDetails?.name &&
          productSample.shippingDetails.country
        ) {
          const payload = createMerchSampleOrderRequestBody(
            productSample,
            productId,
            email,
            phoneNumber,
            editProduct,
            newProduct,
            artistId
          );
          const response = await merch.createMerchSampleOrder(payload);

          if (response.success && response.order && response.orderId) {
            const results: Actions[] = [
              new CreateSampleOrderSuccess({
                orderId: response.orderId,
                order: response.order,
              }),
            ];
            const request = createMerchRequest(state.merch);
            const artistId = state.artist.active?.id;

            if (artistId && request && response.orderId) {
              results.push(
                new UpdateMerch(
                  request as UpdateProductRequest,
                  productId.toString(),
                  artistId,
                  false,
                  true,
                  response.orderId
                )
              );
            }
            return results;
          }
        }
        return [
          new CreateSampleOrderError("Can't create merch order"),
          new ValidateMerchProductSampleError("Can't create merch order"),
          new CreateMerchError("Can't create merch order"),
        ];
      } catch (err) {
        return [
          new CreateSampleOrderError((err as ApiError).message),
          new ValidateMerchProductSampleError((err as ApiError).message),
          new CreateMerchError((err as ApiError).message),
        ];
      }
    }),
    concatMap((actions) => actions)
  );
